import styled, { css, keyframes } from "styled-components";

export const Title = styled.div`
  color: #ffb000;
  font-size: 10px;
  margin: 9px 0;
  text-align: center;
`;

export const InputDiv = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 56px;
  border-radius: 38px;
  background-color: transparent;
  color: #ffb000;
  border: solid 3px #ffb000;
  margin-bottom: 20px;
  /* @media only screen and (max-width: 374px) {
    height: 46px;
  } */
`;
export const InputBig = styled.input`
  width: 100%;
  height: 56px;
  border-radius: 38px;
  background-color: transparent;
  color: #ffb000;
  border: solid 3px #ffb000;
  margin-bottom: 20px;
  outline: none;
  padding: 20px;
  ::placeholder {
    color: #ffb000;
    opacity: 1; /* Firefox */
  }
  /* @media only screen and (max-width: 374px) {
    height: 46px;
  } */
`;
export const StopOnInput = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  height: 56px;
  border-radius: 38px;
  border: solid 3px #ffb000;
  margin-bottom: 20px;
  padding: 10px;
  svg {
    width: 11px;
    height: 12px;
    /* margin: 0 2px; */

  }
  p{
    font-size: 12px;
    line-height: 1;
  }
  input {
    outline: none;
    background: none;
    width: 100%;
    text-overflow: ellipsis;
    font-size: 12px;
    display: flex;
    align: center;
    justify-content: center;
    /* padding-right: 5px; */
    -webkit-box-align: center;
    align-items: center;
    text-align: center;
    /* background-color: transparent; */
    color: #ffb000;
    border: none;
    height: 12px;
    ::placeholder {
      color: #ffb000;
      opacity: 1; /* Firefox */
    }
  }
`;
const textAnim1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,0,1);
     color: #FFB000
  }
  100%{
     color: #ff3920
  } 
`;
const scaleAnim = keyframes`
  0%{
    animation-timing-function: cubic-bezier(.33,1,0,1);
    transform: scale(1)
   }
  50%{
    animation-timing-function: cubic-bezier(0,0,0,1);

    transform: scale(.73)
  }
  100%{
    transform: scale(1)
   } 
`;
const yellowDivOpa1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,0,1);
    opacity: 0;
    }
   
  100%{
    opacity:1
  } 
`;
const textAnim = css`
  ${textAnim1} 0.25s 1 forwards, ${scaleAnim} 0.33s 1 forwards
`;
const yellowDivOpa = css`
  ${yellowDivOpa1} 0.25s 1 forwards
`;
const whiteDivOpa1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,.2,1);
    opacity: 0;
    }
  33%{
    animation-timing-function: cubic-bezier(1.5,3.6,.2,1);
    opacity: 0.5;
    }
  100%{
    opacity:0
  } 
`;
const whiteDivOpa = css`
  ${whiteDivOpa1} 0.5s 1 forwards
`;

export const Reset = styled.div`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: ${(props) => props.active && "#ffb000"}; */
  /* color: ${(props) => props.active && "#ff3920"}; */
  width: 25.25%;
  height: 72%;
  border-radius: 18px;
  font-size: 12px;
  border: solid 3px #ffb000;
  cursor: pointer;
  animation: ${(p) => (p.active ? textAnim : null)};
  .yellow {
    position: absolute;
    width: 106%;
    height: 106%;
    border-radius: 18px;
    background: #ffb000;
    opacity: 0;
    animation: ${(p) => (p.active ? yellowDivOpa : null)};
  }
  .white {
    position: absolute;
    width: 106%;
    height: 106%;
    border-radius: 18px;
    background: #ffffff;
    opacity: 0;
    animation: ${(p) => (p.active ? whiteDivOpa : null)};
  }
  p {
    z-index: 1;
  }
  /* @media only screen and (max-width: 374px) {
    font-size: 10px;
  } */
`;

export const Increase = styled.div`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: ${(props) => props.active && "#ffb000"};
  color: ${(props) => props.active && "#ff3920"}; */
  width: 41.44%;
  height: 72%;
  border-radius: 18px;
  border: solid 3px #ffb000;
  font-size: 12px;
  cursor: pointer;

  animation: ${(p) => (p.active ? textAnim : null)};

  .yellow {
    position: absolute;
    width: 106%;
    height: 106%;
    border-radius: 18px;
    background: #ffb000;
    opacity: 0;
    animation: ${(p) => (p.active ? yellowDivOpa : null)};
  }
  .white {
    position: absolute;
    width: 106%;
    height: 106%;
    border-radius: 18px;
    background: #ffffff;
    opacity: 0;
    animation: ${(p) => (p.active ? whiteDivOpa : null)};
  }
  p {
    z-index: 1;
  }
  /* @media only screen and (max-width: 364px) {
    font-size: 10px;
  } */
`;
export const Input = styled.input`
  width: 41px;
  height: 24px;
  font-size: 16px;
  background-color: transparent;
  border: none;
  outline: none;
  text-align: right;
  color: #ffb000;
  margin-right: 3px;
  ::placeholder {
    color: #ffb000;
  }
`;
const animSG1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(.33,1,0,1);
     transform:scale(1)
  }
  50%{
    animation-timing-function: cubic-bezier(0,0,0,1);
    transform:scale(.73)
  }
  100%{
    transform:scale(1)
   } 
`;

const animSG = css`
  ${animSG1} 0.3s 1 forwards
`;
const whitOpa1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,.2,1);
    opacity:0;
  }
  33%{
    animation-timing-function: cubic-bezier(.15,.36,.2,1);
    opacity:0.5;
   }
  100%{
    opacity:0;
   } 
`;
const whitOpa = css`
  ${whitOpa1} 0.5s 1 forwards
`;
export const PlayBtn = styled.div`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 320px;
  font-size: 20px;
  border-radius: 38px;
  background-color: #ffb000;
  color: #ff3920;
  margin-bottom: 24px;
  padding: 15px 0 17px;
  animation: ${(p) => (p.animSG ? animSG : null)};
  cursor: pointer;

  .white {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    background: #ffffff;
    opacity: 0;
    animation: ${(p) => (p.animSG ? whitOpa : null)};
  }
  /* @media only screen and (max-width: 374px) {
    padding: 12px 0 10px;
    font-size: 18px;
  } */
`;
export const BackBtn = styled.div`
  color: #ffb000;
  font-size: 20px;
  text-align: center;
  width: 100%;
  max-width: 320px;
  cursor: pointer;

  /* @media only screen and (max-width: 374px) {
    font-size: 18px;
  } */
`;
export const Bet = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 320px;
  margin-bottom: 18px;
`;
export const BetQuantity = styled.div`
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 56.69%;
  height: 56px;
  border-radius: 38px;
  border: solid 3px#ffb000;
  color: #ffb000;
  padding: 10px 5px;
  input {
    font-size: 12px;
    text-align: center;
    color: #ffb000;
    background: transparent;
    outline: none;
    border: none;
  }
  /* @media only screen and (max-width: 374px) {
    height: 46px;
    font-size: 10px;
  } */
`;
export const Opr = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 56px;
  border-radius: 28px;
  background-color: #ffb000;
  transform: scale(1);
  cursor: pointer;

  /* transition: all 0.3s; */
  /* color: red; // Todo */
  svg {
    pointer-events: none;
  }
  ${(p) =>
    p.plusPress || p.minusPress
      ? "transform: scale(0.83); transition-timing-function: cubic-bezier(0.33, 1, 0, 0); transition: transform 167ms;"
      : "transform: scale(1); transition-timing-function: cubic-bezier(0, 0, 0, 1); transition: transform 167ms;"}

  ::after {
    content: "";
    position: absolute;
    opacity: 0;
    width: 56px;
    height: 56px;
    border-radius: 28px;
    background-color: white;
    ${(p) =>
    p.plusPress || p.minusPress
      ? "opacity: 0.5;  transition-timing-function: cubic-bezier(0.17, 0.17, 0.2, 1); transition: opacity 167ms;"
      : "opacity: 0;  transition-timing-function: cubic-bezie(0.17, 0.33, 0.2, 1); transition: opacity 333ms"}
  }
  /* :active {
    transform: scale(0.98);
    transition: all 0.3s;
  } */
  /* @media only screen and (max-width: 374px) {
    height: 46px;
    width: 46px;
  } */
`;
export const AutoRuleBox = styled.div`
  position: relative;
  max-width: 320px;
  .infinite {
    position: absolute;
    height: 48px;
    width: 20px;
    top: 26px;
    left: 25px;
    pointer-events: none;
  }

  path {
    fill: #ffb000;
  }
`;
export const ProfitBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 320px;
  width: 100%;

  div {
    width: 47.306%;
  }
  div > div {
    width: 100%;
  }
`;
